// extracted by mini-css-extract-plugin
module.exports = {"google-ai-prompts":"GoogleAIPrompts_google-ai-prompts__mJMr3"};